import { graphql } from "../gql";

export const getDrgClaimQueryDoc = graphql(`
  query drgClaim($id: ID!, $includeAuditorCodes: Boolean!) {
    drgClaim(id: $id) {
      id
      externalClaimId
      patientName
      patientAge
      patientSex
      provider
      dischargeDate
      lengthOfStayDays
      mdcCode
      mdcLabel
      grouperType
      grouperVersion
      originalGrouping {
        drgCode
        drgDescription
        relativeWeight
        soi
        rom
        ccMcc
      }
      recalculatedGrouping {
        drgCode
        drgDescription
        relativeWeight
        rwDeltaVsBilled
        soi
        rom
        ccMcc
      }
      estimatedOverpaymentCents
      allowedAmount
      drgStatus
      errorMessage
      errorType
      # The grouper's immutable answer, rendered by the Original View. Moving
      # codes in the Final View must not change this list.
      #
      # createdBy and findingId only exist on the claim-code-management backend.
      # They are selected solely for the auditor/original views, so they are
      # skipped (JIT-included) when the new flow is disabled and the backend may
      # not expose them yet.
      codes {
        id
        codeKind
        code
        codeDescription
        role
        paymentImpact
        paymentImpactAmount
        poa
        soi
        rom
        finalCcMccFlag
        claimCodeStatus
        createdBy @include(if: $includeAuditorCodes) {
          ...DrgUserFields
        }
        findingId @include(if: $includeAuditorCodes)
        metadata {
          code
          description
          hierarchy
          isBillable
          notes
        }
      }
      # The mutable list the auditor edits (add/delete/reorder). Only exists on
      # the claim-code-management backend, so it is skipped when the new flow is
      # disabled.
      auditorCodes @include(if: $includeAuditorCodes) {
        ...DrgClaimCodeFields
      }
      returnFlags {
        id
        code
        description
        severity
        acknowledgedAt
        acknowledgedBy {
          ...DrgUserFields
        }
      }
      findings {
        ...DrgFindingFields
      }
      annotations {
        id
        page
        quote
        note
        fileId
        fileName
        citationKey
        sourceText
        evidenceItemId
        coordinates {
          left
          top
          width
          height
        }
        author {
          ...DrgUserFields
        }
        linkedFinding {
          id
          code
          codeDescription
          verdict
        }
        createdAt
        updatedAt
        deletedAt
      }
      agentRuns {
        id
        claimId
        status
        triggeredBy
        selectedAgents
        failedAgents
        findingsWritten
        startedAt
        completedAt
      }
      auditTrail {
        ...DrgAuditEventFields
      }
      createdAt
      updatedAt
    }
  }
`);
